import type { JSX } from 'react'

export const EyeOpenIcon = (): JSX.Element => (
  <use href='#eyeOpenIcon' height='100%' width='100%' />
)
